import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'adwary_favorite_salons';

function readFavorites() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState(readFavorites);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  }, [favorites]);

  const isFavorite = useCallback(
    (businessId) => favorites.includes(businessId),
    [favorites]
  );

  const toggleFavorite = useCallback((businessId, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setFavorites((prev) =>
      prev.includes(businessId)
        ? prev.filter((id) => id !== businessId)
        : [...prev, businessId]
    );
  }, []);

  const removeFavorite = useCallback((businessId) => {
    setFavorites((prev) => prev.filter((id) => id !== businessId));
  }, []);

  const pruneFavorites = useCallback((validBusinessIds) => {
    const valid = new Set(validBusinessIds);
    setFavorites((prev) => {
      const pruned = prev.filter((id) => valid.has(id));
      return pruned.length === prev.length ? prev : pruned;
    });
  }, []);

  return { favorites, isFavorite, toggleFavorite, removeFavorite, pruneFavorites };
}
